module.exports = __webpack_public_path__ + "img/go_shops.c2a4f2d0.svg";